import React from "react";

const AppLinks = () => {
  return (
    <div style={{ display: "flex", flexDirection: 'row', gap: "20px" }}>
      <a href="https://play.google.com/store/apps/details?id=your.app.id">
        <img src='google-play.png' alt="Google Play" width="150" />
        <p style={{ color: "rgb(200, 200, 200)" }}>Get it on Google Play</p>
      </a>

      <a href="https://apps.apple.com/app/idYOUR_APP_ID">
        <img src={'app-store.png'} alt="App Store" width="150" />
        <p style={{ color: "rgb(200, 200, 200)" }}>Download on the App Store</p>
      </a>
    </div>
  );
};

export default AppLinks;
